import { ScrollRoot, ScrollViewport, ScrollScrollbar, ScrollThumb, NoScroll } from './styles'

export function ScrollAreaRoot({ children, height, className, noScroll = false, noPadding = false }) {

  if (noScroll) return <NoScroll className={className} noPadding={noPadding}>{children}</NoScroll>

  return (
    <ScrollRoot type="hover" height={height}>
      <ScrollViewport className={className} noPadding={noPadding}>
        {children}
      </ScrollViewport>
      <ScrollScrollbar orientation="vertical">
        <ScrollThumb />
      </ScrollScrollbar>
    </ScrollRoot>
  )
}
